import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=117f9e22&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"
import style0 from "./NavLink.vue?vue&type=style&index=0&id=117f9e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f9e22",
  null
  
)

export default component.exports